import React, { ReactElement } from 'react';
import { ButtonProps } from 'atomic/button/button.interface';
import getButtonClasses from 'atomic/button/button.helper';

const Button: React.FC<ButtonProps> = ({
    tag = 'button',
    ariaLabel,
    title,
    className,
    size = 'md',
    color,
    block = false,
    uppercase = false,
    weight = '500',
    type = 'button',
    onClick,
    noWrap,
    border = false,
    disabled,
    children,
    ...rest
}): ReactElement => {
    const classes = getButtonClasses({ color, block, uppercase, size, weight, noWrap, disabled, border, className });

    return React.createElement(tag, {
        'type': tag === 'button' ? type : void 0,
        onClick,
        'className': classes,
        'aria-label': ariaLabel,
        title,
        disabled,
        ...rest
    }, children);
};

export default Button;
